import type { ReferralDataField } from './referral'
import { referralFields } from './referral-field-definitions'

export const allReferralFields = Object.keys(referralFields) as ReferralDataField[]
